/**
 * The one place the update feature reloads the page.
 *
 * Its own module so tests can replace it: jsdom's `window.location.reload` is
 * an unforgeable, non-configurable property that can be neither spied on nor
 * redefined.
 */

/** Reload the document, which fetches the current `index.html` and bundle. */
export function reloadPage(): void {
  window.location.reload();
}
